module.exports = "<div> <kendo-grid class=sysAdminGridK options=$ctrl.gridOptions data-source=$ctrl.gridDataSource rebind=$ctrl.gridDataSource> </kendo-grid> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/hierarchy-grid/hierarchyGrid.html
// module id = ./app/hierarchy-grid/hierarchyGrid.html
// module chunks = 8